export default {
  methods: {
    nextStep() {
      this.$store.step++;
    },
    previousStep() {
      this.$store.step--;
    },
    helloWorld() {
      window.alert('hello')
    }
  }
};
